import { render, staticRenderFns } from "./GeneralMedicine.vue?vue&type=template&id=3702f51a&scoped=true"
import script from "./GeneralMedicine.vue?vue&type=script&lang=js"
export * from "./GeneralMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702f51a",
  null
  
)

export default component.exports